module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADCSURBVHgBlZGxDYJgEIXfHZFYUECBNSPoBOIURiucgFXYwFAYxlA2YAP/nkJCLBCJJwgkFkbgqy6X711yd4QO83Y0dX3ui8AlwO3aiUCC1NiHvUetHDn6DOe6dPAbVT6xyayd+gQW9+j6R/4KFSvNzk8eEXkYxtSYHwwmHyMR4jUTaDk20ByDMREW4DLBT5jkFY+1BRxwWZVBXasRvkqNbciZdci4fspASHVO++keO4+8eiu/v1yzHwnisiqCZnDTewNv7kAF4vkOJQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/dot-active.png
// module id = Luav
// module chunks = 1